import * as Sentry from '@sentry/vue';

import { createRouter, createWebHistory } from 'vue-router';

import Layout from './LayoutView.vue';
import Tcaptcha from '@/views/h5/tc_aptcha/Index.vue';
import Transional from '../views/TransitionalPage.vue';
import { handleAuth } from '@/utils/auth';

// flutter内嵌h5页面路由
const h5Router = [
  {
    path: '/webview',
    name: '/webview',
    component: () => import('../views/mobile_h5/webview/Index.vue')
  },
  {
    path: '/docPreview',
    name: '/docPreview',
    component: () => import('../views/mobile_h5/doc_preview/Index.vue')
  },
  {
    path: '/h5/article',
    name: 'mobileArticle',
    component: () => import('@/views/h5/square/article/Index.vue')
  },
  {
    path: '/h5/moments',
    name: 'mobileMoments',
    meta: {
      title: '广场 -【一个翻译人的娱乐圈】'
    },
    component: () => import('@/views/h5/square/moments/Index.vue')
  },
  {
    path: '/h5/discussion',
    name: 'mobileDiscussion',
    meta: {
      title: '广场 -【一个翻译人的娱乐圈】'
    },
    component: () => import('@/views/h5/square/discussion/Index.vue')
  },
  {
    path: '/h5/tcaptcha',
    name: 'tcAptcha',
    meta: {
      title: 'h5登录滑块验证',
      bodyBackground: 'transparent',
      loginRequired: false
    },
    component: Tcaptcha
  },
  {
    path: '/h5/rules',
    children: [
      {
        path: 'privacy',
        name: 'Privacy', //隐私协议
        title: '隐私政策和用户协议',
        component: () => import('@/views/h5/rules/Privacy.vue'),
        meta: {
          title: '隐私政策和用户协议',
          loginRequired: false
        }
      },
      {
        path: 'service',
        name: 'Service', //服务协议
        component: () => import('@/views/h5/rules/Service.vue'),
        meta: {
          title: '服务协议',
          loginRequired: false
        }
      }
    ]
  },
  {
    path: '/h5/chat/index',
    name: 'chatHome',
    meta: {
      title: '任度大模型免费体验',
      loginRequired: false
    },
    component: () => import('../views/h5/chat/Index.vue')
  },
  {
    path: '/h5/chat/dialogue',
    name: 'chatDialogue',
    meta: {
      title: '任度大模型免费体验',
      loginRequired: false
    },
    component: () => import('../views/h5/chat/Dialogue.vue')
  }
];

// 业务页面路由
const pageRoutes = [
  {
    path: '/transional',
    // redirect: '/test/dot/startDotChoiceTest',
    name: 'transional',
    component: Transional,
    children: []
  },
  {
    path: '/test/dot/startDotChoiceTest',
    name: 'index',
    component: () => import('../views/TestQuestion.vue')
  },
  {
    path: '/test/dot/result',
    name: 'result',
    component: () => import('../views/TestResult.vue')
  },
  // 低代码路由
  {
    path: '/amis/detail/:id',
    component: () => import('@/views/amis_page/Index.vue'),
    name: 'amisManage',
    meta: {
      title: '低代码管理'
    }
  },
  // 登录回跳中间页
  {
    path: '/logincallback',
    component: () => import('../views/LoginCallback.vue'),
    name: 'loginCallback',
    meta: {
      title: '登录中'
    }
  },
  // 广场静态页
  {
    path: '/square',
    component: () => import('../views/square/Index.vue'),
    name: 'square',
    meta: {
      title: '广场'
    }
  },
  {
    path: '/userCenter', // 个人中心
    name: 'UserCenter',
    component: () => import('../views/user_center/Index.vue'),
    redirect: '/userCenter/resume', //简历
    children: [
      {
        path: 'resume',
        name: 'Resume', //简历
        component: () => import('../views/user_center/Resume.vue')
      },
      {
        path: 'account',
        name: 'Account', //现金资产
        component: () => import('../views/user_center/account/Index.vue')
      },
      {
        path: 'corpus',
        name: 'Corpus', //我的语料
        component: () => import('../views/user_center/corpus/index.vue'),
        children: [
          {
            path: 'home',
            name: 'corpusHome',
            component: () =>
              import('../views/user_center/corpus/home/index.vue')
          },
          {
            path: 'add', //新增
            name: 'corpusAdd',
            component: () => import('../views/user_center/corpus/add/index.vue')
          },
          {
            path: 'detail', //详情
            name: 'corpusDetail',
            component: () =>
              import('../views/user_center/corpus/detail/index.vue')
          }
        ]
      },
      {
        path: 'term',
        name: 'Term', //行业术语库
        component: () => import('../views/user_center/term/Index.vue'),
        children: [
          {
            path: 'add', //新增
            name: 'termAdd',
            component: () => import('../views/user_center/term/add/Index.vue')
          },
          {
            path: 'detail', //行业术语库
            name: 'termDetail',
            component: () => import('../views/user_center/term/detail.vue')
          },
          {
            path: 'audit',
            name: 'Audit', //行业术语库审核
            component: () =>
              import('../views/user_center/term/term-list/Index.vue')
          }
        ]
      },
      {
        path: 'workload',
        name: 'Workload', //现金资产
        component: () => import('../views/user_center/workload/Index.vue')
      }
    ]
  },
  {
    path: '/translator', //客态
    name: 'Translator',
    component: () => import('../views/user_center/Translator.vue')
  },
  // 圈子
  {
    path: '/circle/manage',
    name: 'Circle',
    component: () => import('../views/circle/Index.vue'),
    redirect: '/circle/manage/circleManage',
    children: [
      {
        path: 'circleManage/:id', //圈子管理
        name: 'circleManage',
        component: () => import('../views/circle/manage/CircleManage.vue')
      },
      {
        path: 'memberManage/:id', //成员管理
        name: 'memberManage',
        component: () => import('../views/circle/manage/MemberManage.vue')
      },
      {
        path: 'circleData/:id', //圈子数据
        name: 'circleData',
        component: () => import('../views/circle/manage/CircleData.vue')
      },
      {
        path: 'circleCheck/:id', //抽检记录
        name: 'circleCheck',
        component: () => import('../views/circle/manage/CircleCheck.vue')
      },
      {
        path: 'circlePushSettings/:id', //圈子推送设设置
        name: 'circlePushSettings',
        component: () => import('../views/circle/manage/CirclePushSettings.vue')
      },
      {
        path: 'circleOrderList/:id', //圈子订单列表
        name: 'circleOrderList',
        component: () => import('../views/circle/manage/CircleOrderList.vue')
      }
    ]
  },
  {
    path: '/circle/manage/circleCheckDetail/:id', //抽检详情
    name: 'circleCheckDetail',
    component: () => import('../views/circle/manage/CircleCheckDetail.vue')
  },
  // 404路由
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/orders'
  },
  {
    path: '/loading',
    component: () => import('@/views/Loading.vue')
  }
];

// 活动页路由
const actDirectory = 'certificate2';
const actPagesRoutes = [
  {
    path: '/act',
    name: 'Act',
    component: Layout,
    redirect: '/act/cert/certificateIndex', //理论应该定位到活动列表页，但是没有
    children: [
      {
        path: '/act/cert', //等有列表页就提出来加载。
        name: 'Cert',
        component: Layout,
        redirect: '/act/cert/certificateIndex',
        children: [
          {
            path: 'certificateIndex',
            name: 'CertificateIndex',
            component: () =>
              import(`../landing/${actDirectory}/CertificateIndex.vue`)
          },
          {
            path: 'transApply',
            name: 'TransApply',
            component: () => import(`../landing/${actDirectory}/TransApply.vue`)
          },
          {
            path: 'groupCode',
            name: 'GroupCode', //二维码页面
            component: () =>
              import(`../landing/${actDirectory}/GroupWxCode.vue`)
          },
          {
            path: 'translationVolume',
            name: 'TranslationVolume',
            component: () =>
              import(`../landing/${actDirectory}/TranslationVolume.vue`)
          },
          {
            path: 'honorCertificate',
            name: 'HonorCertificate',
            component: () =>
              import(`../landing/${actDirectory}/HonorCertificate.vue`)
          },
          {
            path: 'abilityReport',
            name: 'AbilityReport',
            component: () =>
              import(`../landing/${actDirectory}/AbilityReport.vue`)
          }
        ]
      }
    ]
  },
  {
    path: '/dotguide',
    name: 'DotGuide',
    redirect: '/dotguide/dotguideIndex',
    children: [
      {
        path: 'dotguideIndex',
        name: 'DotguideIndex',
        component: () => import('../landing/dotGuide/dotGuideIndex.vue')
      },
      {
        path: 'mobile-dotguideIndex',
        name: 'mobileDotguideIndex',
        component: () => import('../landing/dotGuide/dotGuideIndex-m.vue')
      }
    ]
  }
];

// 行为规则页路由
const rulePagesRoutes = [
  {
    path: '/rules',
    name: 'squareRules',
    meta: {
      title: '广场行为规范'
    },
    component: () => import('../landing/SquareRules.vue')
  }
];

// 轻任务
const dotRouter = [
  {
    path: '/dot',
    component: () => import('@/views/dot/Index.vue'),
    children: [
      {
        path: '',
        redirect: '/orders/platform'
      },
      // {
      //   path: 'pe',
      //   name: 'transPage',
      //   meta: {
      //     title: '云译客再进化，轻任务来啦'
      //   },
      //   component: () => import('@/views/dot/pe/Index.vue')
      // },
      {
        path: 'marketing',
        name: 'marketingPage',
        redirect: '/orders/platform',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/dot/market/MarketingPage.vue')
      },
      {
        path: 'pe',
        name: 'pe',
        redirect: '/orders/platform',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/new_dot/peOrder/Index.vue')
      },
      {
        path: 'transkit',
        name: 'transkit',
        redirect: '/orders/platform',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/new_dot/transkitOrder/Index.vue')
      },
      {
        path: 'mark',
        name: 'mark',
        redirect: '/orders/platform',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/new_dot/markOrder/Index.vue')
      },
      {
        path: ':name/detail/:id',
        name: 'orderDetail',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () =>
          import('@/views/new_dot/components/order_detail/Index.vue')
      }
    ]
  },
  {
    path: '/dot/sentFeedback',
    name: 'feedback',
    component: () => import('@/views/dot/feedback/FeedbackPage.vue')
  }
];

//词条任务
const taskRouter = [
  {
    path: '/taskweb',
    name: 'Task',
    component: () => import('../views/task/Index.vue'),
    redirect: '/taskweb/entry',
    children: [
      {
        path: 'entry',
        name: 'Entry',
        redirect: '/orders/platform',
        meta: {
          title: '词条任务'
        },
        component: () => import('@/views/task/entry/Index.vue')
      }
    ]
  },
  {
    path: '/taskweb/entry/detail/:id',
    name: 'EntryDetail',
    meta: {
      title: '词条任务'
    },
    component: () => import('@/views/task/entry/Detail.vue')
  }
];

const operationRouter = [
  {
    path: '/operation',
    name: 'operation',
    component: () => import('../views/operation/Index.vue')
  },
  {
    path: '/operation/records',
    name: 'operationRecords',
    component: () => import('../views/operation/records/Index.vue'),
    children: [
      {
        path: '',
        name: 'dotOperationHistory',
        meta: {
          title: '历史活动记录'
        },
        component: () => import('../views/operation/records/History.vue')
      },
      {
        path: 'myreward',
        name: 'dotOperationMyReward',
        meta: {
          title: '我的活动奖励'
        },
        component: () => import('../views/operation/records/MyReward.vue')
      }
    ]
  }
];

// 订单
const orderRouter = [
  {
    path: '/orders',
    component: () => import('@/views/orders/Index.vue'),
    children: [
      {
        path: '',
        redirect: '/orders/platform'
      },
      {
        path: 'platform',
        name: 'PlatformOrders',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/orders/platform/Index.vue')
      },
      {
        path: ':name/detail/:id',
        name: 'TaskDetail',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () =>
          import('@/views/orders/platform/order_detail/Index.vue')
      },
      {
        path: ':name/dot_detail/:id',
        name: 'DotTaskDetail',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () =>
          import('@/views/orders/platform/order_detail/dot_detail/Index.vue')
      },
      {
        path: 'outside',
        name: 'OutsideOrders',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/orders/outside/Index.vue')
      },
      {
        path: 'recruit',
        name: 'RecruitOrders',
        meta: {
          title: '云译客再进化，轻任务来啦'
        },
        component: () => import('@/views/orders/recruit/Index.vue')
      }
    ]
  },
  {
    path: '/dot/sentFeedback',
    name: 'feedback',
    component: () => import('@/views/dot/feedback/FeedbackPage.vue')
  },
  {
    path: '/task/submit',
    name: 'SubmitTask',
    component: () => import('@/views/h5/task/submit/index.vue')
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...h5Router,
    ...pageRoutes,
    ...actPagesRoutes,
    ...rulePagesRoutes,
    ...dotRouter,
    ...taskRouter,
    ...operationRouter,
    ...orderRouter
  ]
});

const beforeEachAction = (to: any) => {
  to.meta?.title && ((window as any).document.title = to.meta.title);
  (window as any).document.body.style.backgroundColor =
    to.meta?.bodyBackground || '#FAFAFC';
};
const afterEachAction = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0; // firefox
};

router.beforeEach((to, from, next) => {
  if (to.meta.loginRequired != false) {
    handleAuth(to, from, next);
  }
  beforeEachAction(to);
  next();
  afterEachAction();
});

router.onError((error, to) => {
  const errors = [
    'TypeError: error loading dynamically imported module',
    'Failed to fetch dynamically imported module'
  ];

  errors.forEach((item) => {
    if (error.message.includes(item)) {
      window.location.href = to.fullPath;
      Sentry.captureMessage(
        `${item}\n
        重新刷新：${to.fullPath}`
      );
    }
  });
});

export default router;
